import { Chakra } from "@airhelp/react-ui-components";
import BreadcrumbsSchema from "modules/storyblok/components/BreadcrumbsSchema";
import { stickyBottomBarFirstTriggerStyles } from "components/StickyBottomBar";
import StickyBottomBarTrigger from "components/StickyBottomBar/StickyBottomBarTrigger";
import { DataContextProvider } from "contexts/DataContext";
import { useLanguage } from "contexts/LocalizationContext";
import { MobileMenuContextProvider } from "contexts/MobileMenuContext";
import { ModalContextProvider } from "contexts/ModalContext";
import { StickyBottomBarContextProvider } from "contexts/StickyBottomBarContext";
import CustomHead from "modules/common/components/CustomHead";
import Footer from "modules/common/components/Footer";
import HeaderNav from "modules/common/components/HeaderNav";
import CheckCompensationButton from "modules/common/components/HeaderNav/CheckCompensationButton";
import MenuItems from "modules/common/components/HeaderNav/MenuItems";
import PressLogos from "modules/common/components/PressLogos";
import StickyBottomBarAdapter from "modules/storyblok/adapters/StickyBottomBar";
import { useTopMenu } from "utils/menuUtils";
import type { AirHelpScoreWrapperProps } from "./AirHelpScoreWrapper.d";

const { Box } = Chakra;

const AirHelpScoreWrapper = ({
  story,
  cmsLanguagesData,
  serverSideStoryblokPages,
  children,
}: AirHelpScoreWrapperProps) => {
  const {
    content: {
      metaTitle,
      metaDescription,
      breadcrumbsParentPage,
      breadcrumbsPositionName,
      stickyBottomBarHeading,
      hideStickyBottomBar,
      stickyBottomBarVariant,
    },
  } = story;

  const language = useLanguage();
  const topMenu = useTopMenu(language);

  return (
    <DataContextProvider data={{ cmsLanguagesData, serverSideStoryblokPages }}>
      <CustomHead title={metaTitle} description={metaDescription} />
      <BreadcrumbsSchema
        breadcrumbsPositionName={breadcrumbsPositionName}
        breadcrumbsParentPage={breadcrumbsParentPage}
      />

      <MobileMenuContextProvider>
        <ModalContextProvider>
          <HeaderNav menuItems={<MenuItems menu={topMenu} />} headerButtons={<CheckCompensationButton />} />
          <StickyBottomBarTrigger type="first" styles={stickyBottomBarFirstTriggerStyles} />
          <Box pt={32} as="main">
            {children}
          </Box>
          <PressLogos />
          <Footer />
        </ModalContextProvider>
      </MobileMenuContextProvider>
      <StickyBottomBarAdapter
        showStickyBottomBar={!hideStickyBottomBar}
        stickyBottomBarVariant={stickyBottomBarVariant}
        stickyBottomBarHeading={stickyBottomBarHeading}
      />
    </DataContextProvider>
  );
};

const AirHelpScoreAdapter = (props) => (
  <StickyBottomBarContextProvider threshold={0.4}>
    <AirHelpScoreWrapper {...props} />
  </StickyBottomBarContextProvider>
);

export default AirHelpScoreAdapter;
